import fixturesActionTypes from "./fixtures.types";

const INITIAL_STATE = {
  isAllFixturesLoading: false,
  isUserFixturesLoading: false,
  isCreatorFixturesLoading: false,
  isTournamentFixturesLoading: false,
  allFixtures: [],
  userFixtures: [],
  creatorFixtures: [],
  tournamentFixtures: [],
  lastTournamentId: null,
  tournamentViewMode: "subscriber",
  error: null,
};

const fixturesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case fixturesActionTypes.FETCH_USER_FIXTURES_START:
      return {
        ...state,
        isUserFixturesLoading: true,
        error: null,
      };
    case fixturesActionTypes.FETCH_ALL_FIXTURES_START:
      return {
        ...state,
        isAllFixturesLoading: true,
        error: null,
      };
    case fixturesActionTypes.FETCH_CREATOR_FIXTURES_START:
      return {
        ...state,
        isCreatorFixturesLoading: true,
        error: null,
      };
    case fixturesActionTypes.FETCH_TOURNAMENT_FIXTURES_START:
      return {
        ...state,
        isTournamentFixturesLoading: true,
        error: null,
      };
    case fixturesActionTypes.FETCH_USER_FIXTURES_SUCCESS:
      return {
        ...state,
        isUserFixturesLoading: false,
        userFixtures: action.payload,
      };
    case fixturesActionTypes.FETCH_ALL_FIXTURES_SUCCESS:
      return {
        ...state,
        isAllFixturesLoading: false,
        allFixtures: action.payload,
      };
    case fixturesActionTypes.FETCH_CREATOR_FIXTURES_SUCCESS:
      return {
        ...state,
        isCreatorFixturesLoading: false,
        creatorFixtures: action.payload,
      };
    case fixturesActionTypes.FETCH_TOURNAMENT_FIXTURES_SUCCESS:
      return {
        ...state,
        isTournamentFixturesLoading: false,
        tournamentFixtures: action.payload.fixtures || action.payload,
        lastTournamentId: action.payload.tournamentId || state.lastTournamentId,
        tournamentViewMode: action.payload.viewMode || state.tournamentViewMode,
      };
    case fixturesActionTypes.FETCH_USER_FIXTURES_FAILURE:
      return {
        ...state,
        isUserFixturesLoading: false,
        error: action.payload,
      };
    case fixturesActionTypes.FETCH_ALL_FIXTURES_FAILURE:
      return {
        ...state,
        isAllFixturesLoading: false,
        error: action.payload,
      };
    case fixturesActionTypes.FETCH_CREATOR_FIXTURES_FAILURE:
      return {
        ...state,
        isCreatorFixturesLoading: false,
        error: action.payload,
      };
    case fixturesActionTypes.FETCH_TOURNAMENT_FIXTURES_FAILURE:
      return {
        ...state,
        isTournamentFixturesLoading: false,
        error: action.payload,
      };
    case fixturesActionTypes.CLEAR_TOURNAMENT_FIXTURES:
      return {
        ...state,
        tournamentFixtures: [],
        lastTournamentId: null,
      };
    default:
      return state;
  }
};

export default fixturesReducer;
